import { ToastError } from "components/Global/Toasts/Toasty";
import { call, put, takeLatest } from "redux-saga/effects";
import { generateDefaultActions, makeWritePayload, defaultReturn, makePayload, requestSaga } from "shared-utility/store/utils/helpers";
import { authorizedRequest } from "utils/api";

export const SET_DY_LINE_ITEM_SELECTIONS = generateDefaultActions("SET_DY_LINE_ITEM_SELECTIONS");
export const setDYLineItemSelections = payload => makeWritePayload(SET_DY_LINE_ITEM_SELECTIONS.value, payload);

export const GET_LOAN_BALANCE_BY_ID = generateDefaultActions("GET_LOAN_BALANCE_BY_ID");
export const getLoanBalanceById = payload => makePayload(GET_LOAN_BALANCE_BY_ID.value, payload);
function* getLoanBalanceByIdSaga({ loanId, asOfDate }) {
  const url = `/report-components/loan-principal-balance/${loanId}/${asOfDate}`;
  yield requestSaga(GET_LOAN_BALANCE_BY_ID, url, "GET", null, null, null, true);
}

export const GET_LOAN_TOTAL_BALANCE_BY_ID = generateDefaultActions("GET_LOAN_TOTAL_BALANCE_BY_ID");
export const getLoanTotalBalanceById = payload => makePayload(GET_LOAN_TOTAL_BALANCE_BY_ID.value, payload);
function* getLoanTotalBalanceByIdSaga({ loanId }) {
  const url = `/report-components/loan-total-balance/${loanId}`;
  yield requestSaga(GET_LOAN_TOTAL_BALANCE_BY_ID, url, "GET", null, null, null, true);
}

export const GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI = generateDefaultActions("GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI");
export const getMostRecentAsOfDateAmongRGI = payload => makeWritePayload(GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI.value, payload);
function* getMostRecentAsOfDateAmongRGISaga({ payload }) {
  const url = `/report-groups/instances/${payload.reportGroupId}/recentAsOfDate`;
  yield requestSaga(GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI, url, "GET", null, null, null, true);
}

export const GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI = generateDefaultActions("GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI");
export const getMostRecentProjectedAsOfDateAmongRGI = payload => makeWritePayload(GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI.value, payload);
function* getMostRecentProjectedAsOfDateAmongRGISaga({ payload }) {
  const url = `/report-groups/instances/${payload.reportGroupId}/recentAsOfDate`;
  yield requestSaga(GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI, url, "GET", null, null, null, true);
}


export const actionCreators = {
  setDYLineItemSelections,
  getMostRecentAsOfDateAmongRGI,
  getLoanBalanceById,
  getLoanTotalBalanceById
};

const initialState = {
  lineItemType: "fromFile",
  selectedLoanBalance: null,
  activeLoanId: null,
  sourceFileLineItem: null,
  isBalanceLoading: false,
  isTotalBalanceLoading: false,
  loanCurrentPrincipalBalance: null,
  isOutstandingDeptSelected: false,
  loanTotalBalanceAmount: null
};

export const lenderReportDebtYieldLineItemManagementReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case SET_DY_LINE_ITEM_SELECTIONS.value:
      return defaultReturn({ ...state, ...payload });

    case GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI.failure:
      ToastError("Failed to get most recent as of date for report group.  The calculation cannot be completed.");

      return defaultReturn({ ...state }, null, "recentAsOfDate");
    case GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI.success:
      return defaultReturn({ ...state }, payload.data, "recentAsOfDate");

    case GET_LOAN_BALANCE_BY_ID.failure:
      ToastError("Failed to get the outstanding loan balance");

      return defaultReturn({ ...state, isBalanceLoading: false }, null, "loanCurrentPrincipalBalance");
    case GET_LOAN_BALANCE_BY_ID.success:
      return defaultReturn({ ...state, isBalanceLoading: false }, payload.data, "loanCurrentPrincipalBalance");
    case GET_LOAN_BALANCE_BY_ID.value:
      return defaultReturn({ ...state, isBalanceLoading: true });

    case GET_LOAN_TOTAL_BALANCE_BY_ID.failure:
      ToastError("Failed to get the total loan balance");

      return defaultReturn({ ...state, isTotalBalanceLoading: false }, null, "loanTotalBalanceAmount");
    case GET_LOAN_TOTAL_BALANCE_BY_ID.success:
      return defaultReturn({ ...state, isTotalBalanceLoading: false }, payload?.data ?? 0, "loanTotalBalanceAmount");
    case GET_LOAN_TOTAL_BALANCE_BY_ID.value:
      return defaultReturn({ ...state, isTotalBalanceLoading: true });

    default:
      return state;
  }
};

export function* lenderReportDebtYieldLineItemsSaga() {
  yield takeLatest(GET_MOST_RECENT_AS_OF_DATE_AMONG_RGI.value, getMostRecentAsOfDateAmongRGISaga);
  yield takeLatest(GET_MOST_RECENT_PROJECTED_AS_OF_DATE_AMONG_RGI.value, getMostRecentProjectedAsOfDateAmongRGISaga);
  yield takeLatest(GET_LOAN_BALANCE_BY_ID.value, getLoanBalanceByIdSaga);
  yield takeLatest( GET_LOAN_TOTAL_BALANCE_BY_ID.value, getLoanTotalBalanceByIdSaga);
}
